// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2j-IN","rightAdornment":"Header_rightAdornment__3buSH"};